/**
 * Pinned snapshot of Microsoft's Outlook blocked attachment extensions used by
 * QuipexCore #2348 on 2026-08-21.
 */
export const MICROSOFT_OUTLOOK_BLOCKED_EXTENSIONS = [
    '.ade',
    '.adp',
    '.apk',
    '.app',
    '.appcontent-ms',
    '.application',
    '.appref-ms',
    '.appx',
    '.asp',
    '.aspx',
    '.asx',
    '.bas',
    '.bat',
    '.bgi',
    '.cab',
    '.cdxml',
    '.cer',
    '.chm',
    '.cmd',
    '.cnt',
    '.com',
    '.cpl',
    '.crt',
    '.csh',
    '.der',
    '.diagcab',
    '.exe',
    '.fxp',
    '.gadget',
    '.grp',
    '.hlp',
    '.hpj',
    '.hta',
    '.htc',
    '.img',
    '.inf',
    '.ins',
    '.iso',
    '.isp',
    '.its',
    '.jar',
    '.jnlp',
    '.js',
    '.jse',
    '.ksh',
    '.library-ms',
    '.lnk',
    '.mad',
    '.maf',
    '.mag',
    '.mam',
    '.maq',
    '.mar',
    '.mas',
    '.mat',
    '.mau',
    '.mav',
    '.maw',
    '.mcf',
    '.mda',
    '.mdb',
    '.mde',
    '.mdt',
    '.mdw',
    '.mdz',
    '.msc',
    '.mht',
    '.mhtml',
    '.msh',
    '.msh1',
    '.msh2',
    '.mshxml',
    '.msh1xml',
    '.msh2xml',
    '.msi',
    '.msp',
    '.mst',
    '.msu',
    '.ops',
    '.osd',
    '.pcd',
    '.pif',
    '.pl',
    '.plg',
    '.prf',
    '.prg',
    '.printerexport',
    '.ps1',
    '.ps1xml',
    '.ps2',
    '.ps2xml',
    '.psc1',
    '.psc2',
    '.psd1',
    '.psdm1',
    '.pssc',
    '.pst',
    '.py',
    '.pyc',
    '.pyo',
    '.pyw',
    '.pyz',
    '.pyzw',
    '.reg',
    '.scf',
    '.scr',
    '.sct',
    '.search-ms',
    '.settingcontent-ms',
    '.shb',
    '.shs',
    '.theme',
    '.tmp',
    '.udl',
    '.url',
    '.vb',
    '.vbe',
    '.vbp',
    '.vbs',
    '.vhd',
    '.vhdx',
    '.vsmacros',
    '.vsw',
    '.webpnp',
    '.website',
    '.ws',
    '.wsb',
    '.wsc',
    '.wsf',
    '.wsh',
    '.xbap',
    '.xll',
    '.xnk',
] as const;

const ZIP_EXTENSION = '.zip';
const BLOCKED_ORDINARY_DOCUMENT_EXTENSIONS = new Set<string>([
    ...MICROSOFT_OUTLOOK_BLOCKED_EXTENSIONS,
    ZIP_EXTENSION,
]);

export function isOrdinaryDocumentFileNameAllowed(fileName: string): boolean {
    const normalizedName = trimTrailingOrdinaryFileNameSuffix(fileName);
    const extension = extractFinalExtension(normalizedName);

    return (
        extension !== null &&
        !BLOCKED_ORDINARY_DOCUMENT_EXTENSIONS.has(extension)
    );
}

export function isZipArchiveFileName(fileName: string): boolean {
    return extractFinalExtension(fileName) === ZIP_EXTENSION;
}

function trimTrailingOrdinaryFileNameSuffix(fileName: string): string {
    let end = fileName.length;

    while (
        end > 0 &&
        (fileName[end - 1] === ' ' || fileName[end - 1] === '.')
    ) {
        end -= 1;
    }

    return fileName.slice(0, end);
}

function extractFinalExtension(fileName: string): string | null {
    const lastSeparator = Math.max(
        fileName.lastIndexOf('/'),
        fileName.lastIndexOf('\\')
    );
    const lastPeriod = fileName.lastIndexOf('.');

    if (lastPeriod <= lastSeparator || lastPeriod === fileName.length - 1) {
        return null;
    }

    return fileName.slice(lastPeriod).toLowerCase();
}
